export default {
  AudaNet: 'AudaNet',
  AudaBridge: 'AudaBridge'
}
